enum ActionButtonAlignment {
	Start,
	Center,
	End,
}

export default ActionButtonAlignment;
